<template>
  <div class="box-border">
    <div class="border-left"></div>
    <div class="border-right"></div>
  </div>
</template>
<script>
export default {
  name: 'DivisionLine',
}
</script>
<style>
.box-border {
  display: flex;
  margin: 10px 0;
}

.box-border .border-left {
  position: relative;
  width: 20px;
  height: 10px;
  background-color: #24325d;
}

.box-content .box-border .border-left {
  height: 5px;
}

.box-content .box-border .border-left::after {
  right: -5px;
  border-top: 5px solid #24325d;
  border-right: 5px solid transparent;
}

.box-border .border-left::after {
  position: absolute;
  right: -10px;
  content: '';
  width: 0;
  height: 0;
  border-top: 10px solid #24325d;
  border-right: 10px solid transparent;
  z-index: 1;
}

.box-border .border-right {
  position: relative;
  flex: 1;
  height: 10px;
  background-color: #6293c2;
}

.box-content .box-border .border-right {
  height: 5px;
}

</style>


// WEBPACK FOOTER //
// src/components/DivisionLine.vue